export default "__VITE_ASSET__8c4c9288__"